exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags {\n  font-size: smaller;\n  margin-bottom: 5px; }\n\n.tag {\n  border: 2px solid transparent;\n  font-weight: bolder;\n  font-size: small;\n  color: white;\n  background: linear-gradient(to bottom right, #0a0a64, #141496, #1e1ec8, #2828fa);\n  padding: 2px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  border-radius: 10px;\n  margin-right: 3px;\n  cursor: default; }\n\n.selectable {\n  cursor: pointer; }\n\n.selected {\n  border: 2px solid #fac800;\n  color: #fac800; }\n\n.selectable:active {\n  border: 2px solid #fac800 !important;\n  color: #fac800; }\n\n.selected:active {\n  border: 2px solid transparent !important;\n  color: white; }\n\n.projects {\n  overflow: hidden;\n  display: table; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/thunder/git/portfolier/src/app/+portfolio/common.scss
// module id = ../../../../../src/app/+portfolio/common.scss
// module chunks = 1